/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { GridActionsCellItem } from "@mui/x-data-grid";
import {
  Button,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TableCell,
  TableRow,
} from "@mui/material";
import {
  bulkUploadVendors,
  deleteVendor,
  fetchVendor,
  listVendorCategories,
  loadVendors,
  saveVendor,
  totalVendors,
} from "../services/vendors.service";
import { Apartment, Cancel, Contacts, Delete, Edit, Person } from "@mui/icons-material";
import PersonOrgSearch from "../components/modals/personOrgSearch";
import AddNewUser from "../components/modals/addNewUser";
import AddNewOrganization from "../components/modals/addNewOrganization";
import {
  getExpenseAccounts,
  getIdTypes,
} from "../services/list.service";
import {
  isEmptyObject,
  isEmptyString,
  isNullUndefined,
  isValidPhoneNumber,
  sortJSONArray,
} from "../util/util";
import { issueResponseMessage, issueWarnMessage } from "../actions/message";
import ConfirmationModal from "../components/modals/confirmation";
import { ResponsiveRow } from "../constants/layout.constants";
import {
  MainContainer,
  TopBarContainedBrandButton,
  TopBarContainer,
} from "../constants/component.constants";
import { useSelector } from "react-redux";
import AddIndividualVendorModal from "../components/modals/maintenance/vendors/addIndividualVendorModal";
import ChangeVendorContactPerson from "../components/modals/maintenance/vendors/changeVendorContactPerson";
import BulkUploadVendorsModal from "../components/modals/bulkUploadVendors";
import Permit from "../util/permit";
import EditUserModal from "../components/modules/users/editUserModal";
import { getUserRoles, saveUser } from "../services/users.service";
import MuiDataGrid from "../components/modules/MuiDataGrid";
import ManageVendorExpenseItemsModal from "../components/modals/maintenance/vendors/manageVendorExpenseItemsModal";
import { deepOrange, green } from "@mui/material/colors";

export default function Vendors() {
  const user = useSelector((state) => state.auth.user);
  const [vendorName, setVendorName] = useState("");
  const [vendorList, setVendorList] = useState("");
  const [task, setTask] = useState("");
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 50,
  });
  const [total, setTotalVendors] = useState(0);
  const [vendorDetailForm, setVendorDetailForm] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [expenseCategories, setExpenseCategories] = useState([]);
  const [vendorModal, setVendorModal] = useState(false);
  const [vendorExpenseItemsOpen, setVendorExpenseItemsOpen] = useState(false);
  const [addPersonModal, setAddPersonModal] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobilePhone, setMobilePhone] = useState("");
  const [officePhone, setOfficePhone] = useState("");
  const [email, setEmail] = useState("");
  const [idNumber, setIdNumber] = useState("");
  const [idType, setIdType] = useState("");
  const [idTypeOptions, setIdTypeOptions] = useState([]);
  const [vendorCategories, setVendorCategories] = useState([]);
  const [expenseAccountsList, setExpenseAccountsList] = useState([]);
  const [deleteVendorModal, setDeleteVendorModal] = useState(false);
  const [editCompanyContactModal, setEditCompanyContactModal] = useState(false);
  const [titleText, setTitleText] = useState("");
  const [bodyText, setBodyText] = useState("");
  const [positiveText, setPositiveText] = useState("");
  const [negativeText, setNegativeText] = useState("");
  const [type, setType] = useState("");
  const [searchName, setSearchName] = useState("");
  const [personSearchModal, setPersonSearchModal] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [bulkFile, setBulkFile] = useState(null);
  const [bulkFileProgress, setBulkFileProgress] = useState(0);
  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [selectedCompanyContact, setSelectedCompanyContact] = useState();
  const [userRoles, setUserRoles] = useState([]);

  useEffect(() => {
    setLoading(true);
    loadVendors(vendorName, paginationModel.page, paginationModel.pageSize)
      .then((data) => setVendorList(data.sort(sortJSONArray("name", true))))
      .finally(() => {
        setLoading(false);
      });
    totalVendors(vendorName).then((data) => setTotalVendors(data.totalVendors));
  }, [vendorName, paginationModel.page, paginationModel.pageSize, user.proxyFacility]);

  useEffect(() => {
    getIdTypes().then((idTypes) => setIdTypeOptions(idTypes));
    listVendorCategories().then((data) => setVendorCategories(data));
    getExpenseAccounts().then((data) => setExpenseAccountsList(data));
    getUserRoles().then((userRoles) => setUserRoles(userRoles));
  }, []);

  function handleCloseDeleteVendorModal() {
    setDeleteVendorModal(false);
    setSelectedVendor(null);
    setTitleText("");
    setTask("");
    setBodyText("");
    setPositiveText("");
    setNegativeText("");
  }

  const fileValueChanged = (event) => {
    setBulkFile(event.target.files[0]);
  };

  const bulkUploadCancelClicked = () => {
    setBulkFile(null);
    setBulkUploadModal(false);
    setBulkFileProgress(0);
  };

  const validateBulkUploadForm = () => {
    if (isNullUndefined(bulkFile)) {
      issueWarnMessage(
        "Could not determine uploaded file. Please Upload a file first.",
      );
      return false;
    }
    return true;
  };

  const handleSubmitBulkUploadFile = () => {
    let uploadData = new FormData();
    uploadData.append("file", bulkFile);

    if (validateBulkUploadForm()) {
      bulkUploadVendors(uploadData).then((response) => {
        issueResponseMessage(response);
        loadVendors(
          vendorName,
          paginationModel.page | 0,
          paginationModel.pageSize | 50,
        ).then((data) => setVendorList(data.sort(sortJSONArray("name", true))));
        totalVendors(vendorName).then((data) =>
          setTotalVendors(data.totalVendors),
        );
        bulkUploadCancelClicked();
      });
    }
  };

  function handleEditCompanyContactClicked(item) {
    setEditCompanyContactModal(true);
    setSelectedCompanyContact(item.contact);
    setTask("Edit");
  }

  function validateUserForm(sendData) {
    if (isNullUndefined(sendData)) {
      issueWarnMessage(
        "Could not find user data, please refresh the page and try again.",
      );
      return false;
    }
    if (isEmptyString(sendData.firstName) || isEmptyString(sendData.lastName)) {
      issueWarnMessage("First name and Last name are required.");
      return false;
    }
    if (
      isNullUndefined(sendData.mobilePhone) ||
      isEmptyString(sendData.mobilePhone)
    ) {
      issueWarnMessage("Mobile Phone number is required.");
      return false;
    }
    const { isValid, errors } = isValidPhoneNumber(sendData?.mobilePhone);
    if (!isValid) {
      issueWarnMessage(`Mobile phone number is invalid. ${errors.join(". ")}`);
      return false;
    }

    if (sendData?.officePhone) {
      if (sendData?.officePhone === sendData?.mobilePhone) {
        issueWarnMessage(
          `Office phone number cannot be same as mobile phone number. Leave blank if you don't have a separate phone number.`,
        );
        return false;
      }
      const { isValid, errors } = isValidPhoneNumber(sendData?.officePhone);
      if (!isValid) {
        issueWarnMessage(
          `Office phone number is invalid. ${errors.join(". ")}`,
        );
        return false;
      }
    }
    if (
      isNullUndefined(sendData.idNumber) ||
      isEmptyString(sendData.idNumber) ||
      isNullUndefined(sendData.idTypeCd) ||
      isEmptyString(sendData.idTypeCd)
    ) {
      issueWarnMessage("Must provide and ID number and ID type.");
      return false;
    }
    if (isNullUndefined(sendData.email) || isEmptyString(sendData.email)) {
      issueWarnMessage("Must provide an email.");
      return false;
    }

    return true;
  }

  function handleSaveCompanyContactClicked() {
    let params = selectedCompanyContact;
    if (validateUserForm(params)) {
      saveUser(params).then((response) => {
        issueResponseMessage(response);
        loadVendors(
          vendorName,
          paginationModel.page | 0,
          paginationModel.pageSize | 50,
        ).then((data) => setVendorList(data.sort(sortJSONArray("name", true))));
        setEditCompanyContactModal(false);
        setSelectedCompanyContact();
      });
    }
  }

  function handleDeleteVendorClicked(item) {
    let vendorName = item.name;
    setDeleteVendorModal(true);
    setSelectedVendor(item);
    let title = "Confirm Delete Vendor";
    let body =
      "Are you sure you want to delete " +
      vendorName +
      "?" +
      "You will no longer be able to make payments or raise bills for this vendor.";
    setTitleText(title);
    setTask("Delete");
    setBodyText(body);
    setPositiveText("Delete Vendor");
    setNegativeText("Cancel");
  }

  function positiveAction() {
    if (task === "Delete") {
      deleteSelectedVendor();
    }
  }

  function deleteSelectedVendor() {
    if (
      isNullUndefined(selectedVendor) ||
      isNullUndefined(selectedVendor.id) ||
      isEmptyString(selectedVendor.id)
    ) {
      issueWarnMessage(
        "Could not determine Vendor ID for deletion. Try to refresh the page or contact support.",
      );
      return;
    }

    deleteVendor(selectedVendor).then((response) => {
      issueResponseMessage(response);
      loadVendors(
        vendorName,
        paginationModel.page | 0,
        paginationModel.pageSize | 50,
      ).then((data) => setVendorList(data.sort(sortJSONArray("name", true))));
      totalVendors(vendorName).then((data) =>
        setTotalVendors(data.totalVendors),
      );
      handleCloseDeleteVendorModal();
    });
  }

  function searchVendorName(event) {
    let value = event.target.value;
    setVendorName(value);
  }

  function addVendorClicked() {
    setVendorModal(true);
  }

  function handleProceed(org) {
    setSelectedVendor(org);
    setVendorExpenseItemsOpen(true);
    setVendorDetailForm(false);
  }

  function editVendorClicked(item) {
    setType(item.type);
    setTask("Edit");
    setSelectedVendor(item);
    setExpenseCategories(item.expenseCategories);
    setVendorDetailForm(true);
  }

  function handlePersonOrgClose() {
    setVendorModal(false);
  }

  function handlePersonOrgSelect(result) {
    setVendorModal(false);
    fetchVendor(result.id, result.type).then((data) => {
      if (!data) {
        issueWarnMessage("Could not load vendor details. Please try again.");
        return;
      }
      const idTypeCd =
        data.idTypeCd ?? data.idType ?? result.idTypeCd ?? result.idType ?? "";
      const idNumber = data.idNumber ?? result.idNumber ?? "";
      const vendor = {
        ...data,
        type: result.type,
        idTypeCd,
        idType: data.idType ?? data.idTypeCd ?? result.idType ?? result.idTypeCd,
        idNumber,
      };
      setSelectedVendor(vendor);
      setIdType(idTypeCd);
      setIdNumber(idNumber);
      setExpenseCategories(
        data.expenseCategories?.length
          ? data.expenseCategories
          : [{ category: { code: null }, expenseAccount: { id: null } }],
      );
      setType(result.type);
      setTask(data.expenseCategories?.length ? "Edit" : "Create");
      setVendorDetailForm(true);
    });
  }

  function validateIndividualVendor(sendData) {
    if (isNullUndefined(sendData)) {
      issueWarnMessage(
        "Could not find vendor data, please refresh the page and try again.",
      );
      return false;
    }
    if (isEmptyString(sendData.firstName) || isEmptyString(sendData.lastName)) {
      issueWarnMessage("First name and Last name are required.");
      return false;
    }
    if (
      isNullUndefined(sendData.mobilePhone) ||
      isEmptyString(sendData.mobilePhone)
    ) {
      issueWarnMessage("Mobile Phone number is required.");
      return false;
    }
    const { isValid, errors } = isValidPhoneNumber(sendData?.mobilePhone);
    if (!isValid) {
      issueWarnMessage(`Mobile phone number is invalid. ${errors.join(". ")}`);
      return false;
    }

    if (sendData?.officePhone) {
      if (sendData?.officePhone === sendData?.mobilePhone) {
        issueWarnMessage(
          `Office phone number cannot be same as mobile phone number. Leave blank if you don't have a separate phone number.`,
        );
        return false;
      }
      const officePhoneValidation = isValidPhoneNumber(sendData?.officePhone);
      if (!officePhoneValidation.isValid) {
        issueWarnMessage(
          `Office phone number is invalid. ${officePhoneValidation.errors.join(". ")}`,
        );
        return false;
      }
    }

    const idTypeCd = sendData.idTypeCd ?? sendData.idType;
    if (
      isNullUndefined(sendData.idNumber) ||
      isEmptyString(sendData.idNumber) ||
      isNullUndefined(idTypeCd) ||
      isEmptyString(idTypeCd)
    ) {
      issueWarnMessage("Must provide and ID number and ID type.");
      return false;
    }

    return true;
  }

  function validateForm(sendData) {
    const vendorType = sendData?.type ?? type;
    if (vendorType === "Individual" && !validateIndividualVendor(sendData)) {
      return false;
    }

    if (
      isNullUndefined(sendData.expenseCategories) ||
      sendData.expenseCategories.length === 0
    ) {
      issueWarnMessage(
        "You must add at least one Category and Expense account for this vendor",
      );
      return false;
    }
    if (sendData?.contact?.mobilePhone) {
      const { isValid, errors } = isValidPhoneNumber(
        sendData?.contact?.mobilePhone,
      );
      if (!isValid) {
        issueWarnMessage(
          `Mobile phone number is invalid. ${errors.join(". ")}`,
        );
        return false;
      }
    }

    if (sendData?.contact?.officePhone) {
      if (sendData?.contact?.officePhone === sendData?.contact?.mobilePhone) {
        issueWarnMessage(
          `Office phone number cannot be same as mobile phone number. Leave blank if you don't have a separate phone number.`,
        );
        return false;
      }
      const { isValid, errors } = isValidPhoneNumber(
        sendData?.contact?.officePhone,
      );
      if (!isValid) {
        issueWarnMessage(
          `Office phone number is invalid. ${errors.join(". ")}`,
        );
        return false;
      }
    }
    //make sure that the expense categories have values selected
    let message = null;
    for (let i = 0; i < sendData.expenseCategories.length; i++) {
      if (isNullUndefined(sendData.expenseCategories[i].category?.code)) {
        message = "You must select a category for each item";
        break;
      }
      if (isNullUndefined(sendData.expenseCategories[i].expenseAccount?.id)) {
        message = "You must select an expense account for each item";
        break;
      }
    }
    if (!isNullUndefined(message)) {
      issueWarnMessage(message);
      return false;
    }

    return true;
  }

  function saveVendorClicked() {
    let obj = {};
    if (selectedVendor !== undefined && selectedVendor !== null) {
      obj = selectedVendor;
    }
    const sendData = { ...obj, expenseCategories, type };
    setSelectedVendor(sendData);

    if (validateForm(sendData)) {
      return saveVendor(sendData).then((response) => {
        issueResponseMessage(response);
        // A rejected save resolves to undefined (the service raises the error
        // toast). Leave the form open so the details can be corrected.
        if (isNullUndefined(response) || response.type === "error") {
          return response;
        }
        loadVendors(
          vendorName,
          paginationModel.page | 0,
          paginationModel.pageSize | 50,
        ).then((data) => setVendorList(data.sort(sortJSONArray("name", true))));
        totalVendors(vendorName).then((data) =>
          setTotalVendors(data.totalVendors),
        );
        handleCancelClicked();
        return response;
      });
    }
  }

  function showAddNewPersonForm(idNoSearch, idTypeSearch) {
    const idTypeCd = idTypeSearch ?? null;
    const idNumber = idNoSearch ?? "";
    let data = {
      id: null,
      firstName: "",
      middleName: null,
      lastName: "",
      mobilePhone: "",
      officePhone: null,
      email: null,
      idNumber,
      idTypeCd,
      idType: idTypeCd,
      categoryNames: null,
      type: "Individual",
      expenseCategories: [
        {
          category: { code: null },
          expenseAccount: { id: null },
        },
      ],
    };
    setVendorModal(false);
    setSelectedVendor(data);
    setIdType(idTypeCd ?? "");
    setIdNumber(idNumber);
    setExpenseCategories(data.expenseCategories);
    setVendorDetailForm(true);
    setTask("Create");
    setType("Individual");
  }

  function showAddNewOrgForm(companySearched) {
    setVendorModal(false);
    setSearchName(companySearched)
    setVendorDetailForm(true);
    setTask("Create");
    setType("Company");
  }

  function handleAddUserClose() {
    setAddPersonModal(false);
  }

  function handleAddOrgClose() {
    setVendorDetailForm(false);
    setSelectedVendor(null);
  }

  function getChipProps(params) {
    if (!isNullUndefined(params.value)) {
      if (params.value === "Company") {
        return {
          icon: <Apartment style={{ fill: deepOrange[500] }} />,
          label: "Company",
          style: {
            borderColor: deepOrange[500],
          },
        };
      } else if (params.value === "Individual") {
        return {
          icon: <Person style={{ fill: green[500] }} />,
          label: "Individual",
          style: {
            borderColor: green[500],
          },
        };
      } else {
        return "N/A";
      }
    }
  }

  const columns = [
    { headerName: "Name", field: "name", minWidth: 350, flex: 1.75 },
    {
      field: "type",
      headerName: "Type",
      minWidth: 150,
      flex: 2,
      renderCell: (params) => {
        return (
          <Chip variant="outlined" size="small" {...getChipProps(params)} />
        );
      },
    },
    {
      headerName: "Vendor Categories",
      field: "categoryNames",
      minWidth: 300,
      flex: 1.5,
    },
    {
      headerName: "Expense Account(s) - Sub Category",
      field: "expenseAccountNames",
      minWidth: 450,
      flex: 2.25,
    },
    {
      headerName: "Actions",
      field: "actions",
      width: 100,
      fleX: 0.5,
      type: "actions",
      getActions: (params) => {
        let arr = [];
        if (
            user.proxyRole === "BLDIR" ||
            user.proxyRole === "BLDMG"
        ) {
          arr.push(
            <GridActionsCellItem
              icon={<Edit />}
              onClick={() => editVendorClicked(params.row)}
              label="Edit Vendor"
              showInMenu
            />,
          );

          if (params.row.type === "Company" && !isEmptyObject(params.row.contact)) {
            arr.push(
              <GridActionsCellItem
                icon={<Contacts />}
                onClick={() => handleEditCompanyContactClicked(params.row)}
                label="Edit Company Contact"
                showInMenu
              />,
            );
          }

          arr.push(
            <GridActionsCellItem
              icon={<Delete />}
              onClick={() => handleDeleteVendorClicked(params.row)}
              label="Delete"
              showInMenu
            />,
          );
        }

        return arr;
      },
    },
  ];

  function categoryChanged(event, index) {
    let value = event.target.value;
    let itemsArray = [...expenseCategories];
    itemsArray[index].category.code = value;
    setExpenseCategories(itemsArray);
  }

  function expenseAccountChanged(event, index) {
    let value = event.target.value;
    let itemsArray = [...expenseCategories];
    itemsArray[index].expenseAccount.id = value;
    setExpenseCategories(itemsArray);
  }

  function handleAddItems() {
    let item = {
      category: { code: null },
      expenseAccount: { id: null },
    };
    setExpenseCategories((expenseCategories) => [...expenseCategories, item]);
  }

  function handleRemoveItem(index) {
    let itemsArray = [...expenseCategories]; // copying the old items array
    itemsArray.splice(index, 1);
    setExpenseCategories(itemsArray);
  }

  let categoryAccountItems = null;

  expenseCategories &&
    expenseCategories.length > 0 &&
    (categoryAccountItems = expenseCategories.map(
      function (categoryAccountItem, i) {
        return (
          <TableRow key={i}>
            <TableCell>
              <Select
                sx={{ width: "90%" }}
                id={"creditAccount" + i}
                value={
                  categoryAccountItem &&
                  categoryAccountItem.category &&
                  categoryAccountItem.category.code
                }
                onChange={(event) => categoryChanged(event, i)}
              >
                {vendorCategories && vendorCategories.length > 0 ? (
                  vendorCategories.map(function (item, i) {
                    let disabled = false;
                    if (type === "Individual" && item.value === "TAX") {
                      disabled = true;
                    }
                    return (
                      <MenuItem
                        key={item.value}
                        value={item.value}
                        disabled={disabled}
                      >
                        {item.label}
                      </MenuItem>
                    );
                  }, this)
                ) : (
                  <MenuItem sx={{ width: "100%" }}>No Results Found</MenuItem>
                )}
              </Select>
            </TableCell>

            <TableCell>
              <Select
                sx={{ width: "90%" }}
                id={"creditAccount" + i}
                value={
                  categoryAccountItem &&
                  categoryAccountItem.expenseAccount &&
                  categoryAccountItem.expenseAccount.id
                }
                onChange={(event) => expenseAccountChanged(event, i)}
              >
                {expenseAccountsList && expenseAccountsList.length > 0 ? (
                  expenseAccountsList.map(function (item, i) {
                    return (
                      <MenuItem key={item.value} value={item.value}>
                        {item.label}
                      </MenuItem>
                    );
                  }, this)
                ) : (
                  <MenuItem sx={{ width: "100%" }}>No Results Found</MenuItem>
                )}
              </Select>
            </TableCell>

            <TableCell>
              <Button
                variant="contained"
                type="submit"
                sx={{ marginLeft: "10px" }}
                onClick={() => handleRemoveItem(i)}
                color="error"
              >
                <Cancel />
              </Button>
            </TableCell>
          </TableRow>
        );
      },
    ));

  function handleCancelClicked() {
    setTask("");
    setSelectedVendor(null);
    setExpenseCategories([]);
    setFirstName("");
    setMiddleName("");
    setLastName("");
    setIdType("");
    setIdNumber("");
    setMobilePhone("");
    setOfficePhone("");
    setEmail("");
    setVendorDetailForm(false);
    setVendorExpenseItemsOpen(false);
    setType("");
  }

  // Shared Component for expense category items.

  function handlePersonSelect(result) {
    let obj = {};
    if (selectedVendor) {
      obj = selectedVendor;
    }
    obj.contact = result;
    setSelectedVendor(obj);
    setPersonSearchModal(false);
  }

  function handleCreateUserClicked(result) {
    let obj = selectedVendor;
    obj.contact = result;
    obj.contact.name = result.firstName + "" + result.lastName;
    setSelectedVendor(obj);
    setAddPersonModal(false);
  }

  return (
    <Permit
      roles="BLDIR,BLDMG,CS"
      services="PREMIUM,HOA,MAINT"
      noPermittedServiceMessage={{
        title: "Access Denied",
        body: (
          <>
            Your current role and/or facility is not permitted to view this
            page. <br /> Please contact your system admin if you feel this is an
            error.
          </>
        ),
      }}
    >
      <MainContainer>
        <TopBarContainer
          container
          sx={{
            width: { xs: "100%", md: "80%" },
            boxShadow: "0 4px 5px 0 rgba(0,0,0,0.5)",
            padding: "20px auto",
          }}
        >
          <ResponsiveRow
            sx={{
              justifyContent: { md: "space-between", xs: "center" },
              width: { xs: "100%", lg: "50%" },
              padding: 0,
            }}
          >
            <FormControl
              fullWidth
              sx={{
                width: { xs: "100%", lg: "50%" },
              }}
            >
              <InputLabel sx={{ fontSize: ".9rem" }} id="vendorsLabel">
                Search vendor's name
              </InputLabel>
              <OutlinedInput
                id="vendorNameSearch"
                value={vendorName}
                label={`Search vendors name`}
                sx={{ width: "100%" }}
                onChange={(event) => searchVendorName(event)}
              />
            </FormControl>
          </ResponsiveRow>

          <Permit roles={"BLDIR,BLDMG"}>
            <ResponsiveRow
              sx={{
                justifyContent: { xs: "center", lg: "flex-end" },
                width: { lg: "50%", xs: "100%" },
                padding: 0,
              }}
            >
              <TopBarContainedBrandButton
                sx={{ width: { xs: "100%", lg: "200px" }, height: "60px" }}
                onClick={() => setBulkUploadModal(true)}
              >
                Bulk Upload Vendors
              </TopBarContainedBrandButton>
              <TopBarContainedBrandButton
                sx={{ width: { xs: "100%", lg: "200px" }, height: "60px" }}
                onClick={addVendorClicked}
              >
                Add Vendor
              </TopBarContainedBrandButton>
            </ResponsiveRow>
          </Permit>
        </TopBarContainer>
        <br />
        <br />

        <MuiDataGrid
          noSelection={true}
          dataGridColumns={columns}
          dataGridRows={vendorList}
          handlePageLoad={setPaginationModel}
          serverPagination={true}
          loading={isLoading}
          height="60vh"
          totalRows={total}
        />

        {/*PERSON/ORG SEARCH MODAL*/}
        {vendorModal && (
          <PersonOrgSearch
            contractType={"vendor"}
            showPersonOrgModal={vendorModal}
            handlePersonOrgClose={handlePersonOrgClose}
            handlePersonOrgSelect={handlePersonOrgSelect}
            showAddNewUserForm={showAddNewPersonForm}
            showAddNewOrgForm={showAddNewOrgForm}
          />
        )}

        {/*ADD NEW USER MODAL*/}
        <AddNewUser
          openModal={addPersonModal}
          closeModal={handleAddUserClose}
          saveUser={
            type === "Individual"
              ? handleCreateUserClicked
              : handlePersonOrgSelect
          }
          manageUsers={false}
        />

        {vendorDetailForm &&
          type === "Individual" && (
            <AddIndividualVendorModal
              vendorDetailForm={vendorDetailForm}
              saveVendorClicked={saveVendorClicked}
              task={task}
              handleAddItems={handleAddItems}
              handleCancelClicked={handleCancelClicked}
              setEmail={setEmail}
              setFirstName={setFirstName}
              setIdType={setIdType}
              setIdNumber={setIdNumber}
              setLastName={setLastName}
              setMiddleName={setMiddleName}
              setMobilePhone={setMobilePhone}
              setOfficePhone={setOfficePhone}
              setSelectedVendor={setSelectedVendor}
              categoryAccountItems={categoryAccountItems}
              email={email}
              firstName={firstName}
              idType={idType}
              idTypeOptions={idTypeOptions}
              idNumber={idNumber}
              lastName={lastName}
              middleName={middleName}
              mobilePhone={mobilePhone}
              officePhone={officePhone}
              selectedVendor={selectedVendor}
            />
          )}

        {vendorDetailForm &&
          type === "Company" && (
            <AddNewOrganization
              openModal={vendorDetailForm}
              saveOrg={saveVendorClicked}
              searchedName={searchName}
              handleSave={true}
              closeModal={handleAddOrgClose}
              selectedOrg={selectedVendor}
              task={task}
              handleProceed={handleProceed}
              contractType="vendor"
            />
          )}

        {vendorExpenseItemsOpen && (
          <ManageVendorExpenseItemsModal 
            handleCancelClicked={handleCancelClicked}
            selectedVendor={selectedVendor}
            vendorExpenseItemsOpen={vendorExpenseItemsOpen}
            categoryAccountItems={categoryAccountItems}
            saveVendorClicked={saveVendorClicked}
            handleAddItems={handleAddItems}
          />
        )}

        <ChangeVendorContactPerson
          openModal={personSearchModal}
          handlePersonSelect={handlePersonSelect}
          setAddPersonModal={setAddPersonModal}
          setPersonSearchModal={setPersonSearchModal}
          setSelectedVendor={setSelectedVendor}
        />

        <EditUserModal
          showAddNewUserForm={editCompanyContactModal}
          handleAddUserClose={() => {
            setEditCompanyContactModal(false);
            setSelectedCompanyContact();
            setTask("");
          }}
          selectedUser={selectedCompanyContact}
          setSelectedUser={(userUpdate) =>
            setSelectedCompanyContact(userUpdate)
          }
          handleSaveUserClicked={handleSaveCompanyContactClicked}
          idTypes={idTypeOptions}
          userRoles={userRoles}
          isCompanyContact={true}
          task={task}
        />

        <ConfirmationModal
          showConfirmationModal={deleteVendorModal}
          handleConfirmationClose={handleCloseDeleteVendorModal}
          title={titleText}
          severity={"error"}
          body={bodyText}
          positiveText={positiveText}
          negativeText={negativeText}
          positiveAction={positiveAction}
          negativeAction={handleCloseDeleteVendorModal}
        />

        {bulkUploadModal && (
          <BulkUploadVendorsModal
            showVendorBulkUploadModal={bulkUploadModal}
            bulkFile={bulkFile}
            bulkFileProgress={bulkFileProgress}
            fileValueChanged={fileValueChanged}
            handleCancelClicked={bulkUploadCancelClicked}
            handleSubmitClicked={handleSubmitBulkUploadFile}
          />
        )}
      </MainContainer>
    </Permit>
  );
}
